if (!customElements.get('hero-typing-heading')) {
  class HeroTypingHeading extends HTMLElement {
    connectedCallback() {
      if (this.dataset.typed === 'true') return;
      this.dataset.typed = 'true';

      const fullText = this.textContent.trim();
      const speed = parseInt(this.dataset.speed, 10) || 45;
      const loop = this.dataset.loop === 'true';
      const startDelay = parseInt(this.dataset.delay, 10) || 200;

      this.textContent = '';
      this.classList.add('hero-typing-heading--typing');

      const typeOnce = (onDone) => {
        let i = 0;
        const step = () => {
          this.textContent = fullText.slice(0, i);
          i++;
          if (i <= fullText.length) {
            setTimeout(step, speed);
          } else if (onDone) {
            onDone();
          }
        };
        step();
      };

      const eraseOnce = (onDone) => {
        let i = fullText.length;
        const step = () => {
          this.textContent = fullText.slice(0, i);
          i--;
          if (i >= 0) {
            setTimeout(step, speed / 2);
          } else if (onDone) {
            onDone();
          }
        };
        step();
      };

      const run = () => {
        typeOnce(() => {
          this.classList.remove('hero-typing-heading--typing');
          this.classList.add('hero-typing-heading--done');
          if (loop) {
            setTimeout(() => {
              this.classList.add('hero-typing-heading--typing');
              this.classList.remove('hero-typing-heading--done');
              eraseOnce(run);
            }, 1800);
          }
        });
      };

      setTimeout(run, startDelay);
    }
  }

  customElements.define('hero-typing-heading', HeroTypingHeading);
}
